import { useState } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import CorusImage from '../CorusImage/CorusImage';

import fallbackImage from '../../inline-images/post-fallback-image.jpg';
import HtmlWrapper from '../Text/HtmlWrapper';

/**
 * @summary Single Featured Show block component.
 * @param {object} props
 * @param {import('./FeaturedShowsTypes').Show} props.show
 * @returns {JSX.Element}
 */
export default function FeaturedShow({ show = null }) {
	const [hover, setHover] = useState(false);

	const name = show?.name ?? '';
	const description = show?.description ?? '';
	const link = show?.uri ?? '';

	const imgUrl = show?.showTag?.tagFeaturedImage?.sourceUrl ?? fallbackImage;
	const imgAlt = show?.showTag?.tagFeaturedImage?.altText ?? '';

	return (
		<div className="shows__grid__item">
			<Link
				href={link}
				aria-label={`Link to the tag page for ${name}`}
				className="profile-img-link"
			>

				<CorusImage
					alt={imgAlt}
					className="profile-img"
					height={565}
					src={imgUrl}
					width={848}
				/>

			</Link>
			<div className={`details hover-style--${Boolean(hover)}`}>
				<Link href={link}>

					<p
						className="name"
						onBlur={() => setHover(false)}
						onFocus={() => setHover(true)}
						onMouseOver={() => setHover(true)}
						onMouseOut={() => setHover(false)}
					>
						{name}
					</p>

				</Link>
				<HtmlWrapper
					html={`<p>${description}</p>`}
					as="div"
					configLevel="standard"
					className="description"
				/>
			</div>
		</div>
	);
}

export const FeaturedShowPropTypes = {
	show: PropTypes.shape({
		name: PropTypes.string,
		description: PropTypes.string,
		uri: PropTypes.string,
		showTag: PropTypes.shape({
			tagFeaturedImage: PropTypes.shape({
				sourceUrl: PropTypes.string,
				altText: PropTypes.string,
			}),
		}),
	}),
};

FeaturedShow.propTypes = FeaturedShowPropTypes;
